export const SUPPORTED_LANGUAGES = ["en", "fr"] as const;

export type AppLanguage = (typeof SUPPORTED_LANGUAGES)[number];

// French is the default — matches `old site/app.js:3` (`let lang = 'fr'`).
export const DEFAULT_LANGUAGE: AppLanguage = "fr";
// Mirrors the legacy `aksara-lang` localStorage key (`old site/app.js:13`).
export const LANGUAGE_STORAGE_KEY = "aksara-lang";
